import { cn } from '../../lib/cn';
import type { OrderRow } from '../../customerops/framework';

type Props = { orders?: OrderRow[] };

function statusColor(status: string) {
  switch (status) {
    case 'packing': return 'bg-warning-100 text-warning-700 dark:bg-warning-950 dark:text-warning-300';
    case 'shipped': return 'bg-brand-100 text-brand-700 dark:bg-brand-950 dark:text-brand-300';
    case 'delivered': return 'bg-success-100 text-success-700 dark:bg-success-950 dark:text-success-300';
    case 'return_requested': return 'bg-error-100 text-error-700 dark:bg-error-950 dark:text-error-300';
    default: return 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400';
  }
}

export function OrderWorkspacePanel({ orders = [] }: Props) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left text-sm">
        <thead>
          <tr className="border-b border-slate-200 text-xs uppercase text-slate-500 dark:border-slate-700">
            <th className="pb-2 pr-4 font-medium">Order</th>
            <th className="pb-2 pr-4 font-medium">Customer</th>
            <th className="pb-2 pr-4 font-medium">Items</th>
            <th className="pb-2 pr-4 font-medium">Value</th>
            <th className="pb-2 pr-4 font-medium">Status</th>
            <th className="pb-2 font-medium">SLA</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((o) => (
            <tr key={o.id} className="border-b border-slate-100 dark:border-slate-800">
              <td className="py-2.5 pr-4 font-medium">{o.id}</td>
              <td className="py-2.5 pr-4">{o.customer}</td>
              <td className="py-2.5 pr-4">{o.items}</td>
              <td className="py-2.5 pr-4">{o.value}</td>
              <td className="py-2.5 pr-4">
                <span className={cn('rounded-full px-2 py-0.5 text-xs font-medium capitalize', statusColor(o.status))}>
                  {o.status.replace('_', ' ')}
                </span>
              </td>
              <td className="py-2.5 text-xs text-slate-500">{o.sla}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
